export default "__VITE_ASSET__a6ea3bc7__"